export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full max-w-xs lg:max-w-sm">
            <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%2C%20minimal%20dark%20UI%20design%20with%20warm%20golden%20accents%2C%20clean%20modern%20layout%2C%20premium%20app%20screenshot%2C%20cinematic%20color%20scheme%2C%20no%20phone%20frame%20visible&width=600&height=800&seq=app-mobile-01&orientation=portrait"
                alt="爱丫爱丫影院移动端观影体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-3">移动观影 · 随时随地</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              爱丫爱丫影院全面适配手机与平板浏览，无论你在地铁通勤、午休间隙还是睡前放松，打开浏览器即可畅享秒开不卡顿的高清观影体验。自适应画质技术根据网络环境智能调节，Wi-Fi 下自动高清、移动数据下优化流畅，让你追剧零负担。
            </p>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-5">
              {['全平台适配', '自适应画质', '收藏同步', '夜间模式', '手势控制'].map((tag) => (
                <span key={tag} className="px-3 py-1 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">{tag}</span>
              ))}
            </div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line"></i>
              立即体验
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}